'use client'
import NotFoundModule from '@/modules/NotFoundModule/NotFoundModule'

const NotFound = (props: any) => {
    return (
        <>
            <img
                src={'/assets/img/bckgr.png'}
                style={{
                    position: 'fixed',
                    zIndex: -2,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    background: 'linear-gradient(180deg, #3156A8 21%, #2D3079 108%)'
                }}
            />
            <NotFoundModule {...{ ...props, notFound: false }} />
        </>
    )
}

export default NotFound
